import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsEleventyComponent } from './simple-icons-eleventy.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsEleventyComponent ],
    exports:      [ SimpleIconsEleventyComponent ],
    bootstrap:    []
})
export class SimpleIconsEleventyModule {}
